import { memo, useCallback, useState } from 'react';
import { ModalExtendedProps } from '@bonanza-social/navigation';
import StatusModal from '../components/StatusModal/StatusModal';
import StatusOnboarding from '../components/StatusOnboarding/StatusOnboarding';

function StatusOnboardingModal({ close }: ModalExtendedProps) {
  const [initialAnimationFinished, setInitialAnimationFinished] =
    useState(false);

  const onInitialAnimationFinished = useCallback(() => {
    setInitialAnimationFinished(true);
  }, []);

  return (
    <StatusModal
      flex={1}
      width="100%"
      maxWidth="auto"
      headerShown={initialAnimationFinished}
      maxHeight={
        !initialAnimationFinished
          ? 'auto'
          : {
              mobile: 'auto',
              tablet: '78.5%',
              desktop: '78.5%',
            }
      }
      close={close}
    >
      <StatusOnboarding
        flex={1}
        onInitialAnimationFinished={onInitialAnimationFinished}
      />
    </StatusModal>
  );
}

export default memo(StatusOnboardingModal);
